<template>
  <div class="ott-made-area movies-made pt-100 pb-75">
    <div class="container">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <h2 class="text-white">ما الذي يجعل سيرفرنا استثنائياً؟</h2>
      </div>

      <div class="row justify-content-center">
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="200 + index * 100"
        >
          <div class="ott-made-card">
            <div class="image">
              <img :src="feature.image" :alt="feature.title" />
            </div>
            <div class="content">
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "WhatMadeExtraordinary",
  setup() {
    const features = ref([
      {
        image: new URL(
          "@/assets/images/ott-platform/made1.png",
          import.meta.url
        ).href,
        title: "ثبات تام بدون تقطيع",
        description: "سيرفرات متطورة ومحمية تضمن لك بثاً مستقراً أثناء المباريات الكبرى والأحداث المباشرة.",
      },
      {
        image: new URL(
          "@/assets/images/ott-platform/made2.png",
          import.meta.url
        ).href,
        title: "جودة فائقة 4K و FHD",
        description: "مشاهدة واضحة ونقية لأقوى الباقات الرياضية والترفيهية بدقة تناسب الشاشات الكبيرة.",
      },
      {
        image: new URL(
          "@/assets/images/ott-platform/made3.png",
          import.meta.url
        ).href,
        title: "توافق مع جميع الأجهزة",
        description: "يعمل السيرفر بمرونة عالية على الشاشات الذكية، الهواتف، التي في ستيك، وأجهزة الكمبيوتر.",
      },
    ]);

    return { features };
  },
});
</script>